import { useMemo } from 'react';
import { useGlobalStore } from '@core/hooks/useGlobalStore';
import { useContextParams } from '@core/params/context';
import { shoppingCartQuickAddSelector, shoppingCartQuickViewSelector, } from '@core/shopping/model';
/**
 * quickAdd and quickView can be toggled through _fwn.shopping.configureCart
 * or widget params. Widget param takes precedence, if params are undefined,
 * global store values are used.
 */
export function useQuickAdd() {
    const quickAddStore = useGlobalStore(shoppingCartQuickAddSelector);
    const quickViewStore = useGlobalStore(shoppingCartQuickViewSelector);
    const { shopping_quick_add: quickAddParam, shopping_quick_view: quickViewParam, } = useContextParams();
    return useMemo(() => ({
        quickAdd: quickAddParam ?? quickAddStore,
        quickView: quickViewParam ?? quickViewStore,
    }), [quickAddParam, quickAddStore, quickViewParam, quickViewStore]);
}
